export const slugify = (str) => " ,.'\":;_?!$@#%^&*()[]{}-".split("").reduce((prev, curr) => prev.replaceAll(curr, "-"), str).toLowerCase()
